import Vue from 'vue'
import { Button, Select, Form, FormItem, Option, Divider} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'



Vue.config.productionTip = false
Vue.use(Button);
Vue.use(Select);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Option);
Vue.use(Divider);


new Vue({
  render: h => h(App),
}).$mount('#app')
